import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fetchedTrolleyItems", "fetchedRecommendationsItems", "openModal", "closeModal", "hideExtras", "hideWarranties", "hideCategories", "addedItems", "addedItemsAttributes", "extraItems", "extraItemsMeta", "warrantyItems", "isGoToTrolleyEnabled", "categoryItems", "categoryItemsMeta", "trackingPage", "trackingPageId", "onClickAdd", "className", "showError", "errorCode", "data-test"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button as BoltButton, Modal as BoltModal } from '@sainsburys-tech/bolt';
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider';
import ModalSuccessState from '../../components/ModalStates/ModalSuccessState';
import ModalFailedState from '../../components/ModalStates/ModalFailesState';
import { flatten } from '../../helpers';
import { closeModal, updateGoToTrolleyEnabled } from '../../actions';
import { modalReducerInitialState } from '../../reducers';
import careTypes from '../../components/WarrantyItem/config/careTypes';
import * as Styled from './Modal.styles';
export var Modal = function Modal(_ref) {
  var fetchedTrolleyItems = _ref.fetchedTrolleyItems,
      fetchedRecommendationsItems = _ref.fetchedRecommendationsItems,
      openModal = _ref.openModal,
      close = _ref.closeModal,
      hideExtras = _ref.hideExtras,
      hideWarranties = _ref.hideWarranties,
      hideCategories = _ref.hideCategories,
      addedItems = _ref.addedItems,
      addedItemsAttributes = _ref.addedItemsAttributes,
      extraItems = _ref.extraItems,
      extraItemsMeta = _ref.extraItemsMeta,
      warrantyItems = _ref.warrantyItems,
      isGoToTrolleyEnabled = _ref.isGoToTrolleyEnabled,
      categoryItems = _ref.categoryItems,
      categoryItemsMeta = _ref.categoryItemsMeta,
      trackingPage = _ref.trackingPage,
      trackingPageId = _ref.trackingPageId,
      onClickAdd = _ref.onClickAdd,
      className = _ref.className,
      showError = _ref.showError,
      errorCode = _ref.errorCode,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      itemsLoaded = _useState2[0],
      setItemsLoaded = _useState2[1];

  var _useVocab = useVocab(),
      BRAND_NAME = _useVocab.BRAND_NAME,
      ITEM_CONTAINER = _useVocab.ITEM_CONTAINER;

  var handleClose = function handleClose() {
    if (openModal) {
      close();
    }
  };

  var extraItemsList = extraItems.map(function (item) {
    return item.id;
  });
  var warrantyItemsList = warrantyItems.length > 0 && warrantyItems.map(function (item) {
    return item.id;
  }) || [];
  var isReady = fetchedTrolleyItems && fetchedRecommendationsItems && itemsLoaded;
  var partNumbers = addedItems.concat(warrantyItemsList).concat(extraItemsList);
  var mainCareType = warrantyItems.length && warrantyItems[0].type || '';
  var noWarranties = hideWarranties || !warrantyItems.length || mainCareType && !Object.keys(careTypes).includes(mainCareType);
  var brand = (BRAND_NAME === null || BRAND_NAME === void 0 ? void 0 : BRAND_NAME.toUpperCase()) || 'ARGOS';
  var brandHideCategories = {
    ARGOS: false,
    HABITAT: true
  }[brand];
  var failedFooter = /*#__PURE__*/React.createElement("div", {
    className: "xs-row"
  }, /*#__PURE__*/React.createElement(Styled.ButtonSpacer, {
    type: "continue",
    className: "xs-12 sm-12--none"
  }, /*#__PURE__*/React.createElement(BoltButton, {
    kind: "secondary",
    full: true,
    onClick: handleClose,
    "data-test": "".concat(dataTest, "-button-continue")
  }, "Continue shopping")));
  var successFooter = isReady && /*#__PURE__*/React.createElement("div", {
    className: "xs-row"
  }, noWarranties && /*#__PURE__*/React.createElement(Styled.ButtonSpacer, {
    type: "continue",
    className: "xs-12 sm-6--none xs-order-2 sm-order-1"
  }, /*#__PURE__*/React.createElement(BoltButton, {
    kind: "secondary",
    full: true,
    onClick: handleClose,
    "data-test": "".concat(dataTest, "-button-continue")
  }, "Continue shopping")), /*#__PURE__*/React.createElement(Styled.ButtonSpacer, {
    type: "att",
    className: "xs-12 sm-6--none xs-order-1 sm-order-2"
  }, /*#__PURE__*/React.createElement(BoltButton, {
    kind: noWarranties ? 'primary' : 'secondary',
    full: true,
    as: isGoToTrolleyEnabled ? 'a' : 'button',
    href: "/basket",
    "data-test": "".concat(dataTest, "-button-basket"),
    disabled: !isGoToTrolleyEnabled
  }, noWarranties ? "Go to ".concat(ITEM_CONTAINER) : 'Continue without insurance')));
  return /*#__PURE__*/React.createElement(BoltModal, _extends({
    heading: showError ? 'An error occurred' : "Added to ".concat(ITEM_CONTAINER),
    show: openModal,
    onClose: handleClose,
    padding: showError,
    height: "auto",
    "data-test": "".concat(dataTest, "-modal"),
    footer: showError ? failedFooter : successFooter,
    size: "lg"
  }, props), showError ? /*#__PURE__*/React.createElement(ModalFailedState, {
    errorCode: errorCode
  }) : /*#__PURE__*/React.createElement(ModalSuccessState, {
    hideExtras: hideExtras,
    hideWarranties: hideWarranties,
    hideCategories: brandHideCategories || hideCategories,
    addedItems: addedItems,
    addedItemsAttributes: addedItemsAttributes,
    extraItems: extraItems,
    extraItemsMeta: extraItemsMeta,
    warrantyItems: warrantyItems,
    categoryItems: categoryItems,
    categoryItemsMeta: categoryItemsMeta,
    trackingPage: trackingPage,
    trackingPageId: trackingPageId,
    onClickAdd: onClickAdd,
    "data-test": dataTest,
    partNumbers: partNumbers,
    warrantyItemsList: warrantyItemsList,
    extraItemsList: extraItemsList,
    isReady: isReady,
    setItemsLoaded: setItemsLoaded
  }));
};
Modal.displayName = 'Modal';
Modal.propTypes = {
  className: PropTypes.string,
  hideExtras: PropTypes.bool,
  hideWarranties: PropTypes.bool,
  hideCategories: PropTypes.bool,
  onClickAdd: PropTypes.func,
  closeModal: PropTypes.func,
  fetchedTrolleyItems: PropTypes.bool,
  fetchedRecommendationsItems: PropTypes.bool,
  openModal: PropTypes.bool,
  addedItems: PropTypes.array,
  extraItems: PropTypes.array,
  warrantyItems: PropTypes.array,
  isGoToTrolleyEnabled: PropTypes.bool,
  categoryItems: PropTypes.array,
  trackingPage: PropTypes.string,
  trackingPageId: PropTypes.string,
  addedItemsAttributes: PropTypes.object,
  // todo: specifiy object shape
  extraItemsMeta: PropTypes.object,
  // todo: specifiy object shape
  categoryItemsMeta: PropTypes.object,
  // todo: specifiy object shape
  updateGoToTrolleyEnabled: PropTypes.func,
  pendingRequestCount: PropTypes.number,
  showError: PropTypes.bool,
  errorCode: PropTypes.string,
  'data-test': PropTypes.string
};
Modal.defaultProps = {
  className: '',
  hideExtras: false,
  hideWarranties: false,
  hideCategories: false,
  onClickAdd: function onClickAdd() {},
  'data-test': 'component-att'
};

var mapStateToProps = function mapStateToProps() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var trolleyModal = state.trolleyModal,
      _state$trolleyItems = state.trolleyItems,
      trolleyItems = _state$trolleyItems === void 0 ? {} : _state$trolleyItems;

  var _ref2 = trolleyModal || true,
      isGoToTrolleyEnabled = _ref2.isGoToTrolleyEnabled;

  var _trolleyItems$failed = trolleyItems.failed,
      failed = _trolleyItems$failed === void 0 ? [] : _trolleyItems$failed,
      _trolleyItems$trolley = trolleyItems.trolleyRequestComplete,
      trolleyRequestComplete = _trolleyItems$trolley === void 0 ? false : _trolleyItems$trolley;
  var showError = failed.length > 0 && trolleyRequestComplete;
  return _objectSpread(_objectSpread({}, flatten(state).trolleyModal || modalReducerInitialState), {}, {
    isGoToTrolleyEnabled: isGoToTrolleyEnabled,
    showError: showError,
    errorCode: showError && failed[failed.length - 1].error
  });
};

export default connect(mapStateToProps, {
  closeModal: closeModal,
  updateGoToTrolleyEnabled: updateGoToTrolleyEnabled
})(Modal);